import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import decode from "jwt-decode";
import { logout } from "../redux/actions/authActions";
const RequireAuth = ({ children }) => {
  const { user } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const token = user?.token;
  console.log(token);
  if (token) {
    const data = decode(token);

    console.log({ data }, "token", data.exp > Date.now() / 1000);

    //if the token is not expired
    if (data.exp > Date.now() / 1000) {
      return <Outlet />;
    } else {
      dispatch(logout("your token expired"));
      //   return <Navigate to="/auth/login" />;
    }
  } else {
    return <Navigate to="/auth/login" />;
  }
};

export default RequireAuth;
